import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-page-type"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", {
    "data-page-type": _ctx.pageType,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeSidebar && _ctx.closeSidebar(...args)))
  }, [
    _createVNode(_Transition, { name: "page-expand" }, {
      default: _withCtx(() => [
        (_ctx.show.value)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.pageContent.component), { key: 0 }))
          : (_openBlock(), _createBlock(_component_Loader, { key: 1 }))
      ]),
      _: 1
    })
  ], 8, _hoisted_1))
}